module.exports = __webpack_public_path__ + "static/clerkie-logo-46af33a6a98f8f27a3faa5f56cc6822c.png";